import { cn } from "@gymflow/helpers";
import { cva, VariantProps } from "class-variance-authority";
import React, { ReactNode } from "react";

const layeredCirclesVariantsInnerCircle = cva(
  "flex size-3/4 items-center justify-center rounded-full",
  {
    variants: {
      intent: {
        primary: "dark:bg-primary-800 bg-primary-100",
        secondary: "dark:bg-secondary-800 bg-secondary-100",
        error: "dark:bg-error-800 bg-error-100",
        warning: "dark:bg-warning-800 bg-warning-100",
        success: "dark:bg-success-800 bg-success-100",
        lightblue: "dark:bg-lightblue-800 bg-lightblue-100",
        default: "bg-gray-100 dark:bg-gray-800",
      },
    },
    defaultVariants: {
      intent: "secondary",
    },
  },
);
const layeredCirclesVariantsOuterCircle = cva(
  "flex size-16 items-center justify-center rounded-full",
  {
    variants: {
      intent: {
        primary: "dark:bg-primary-900 bg-primary-50",
        secondary: "dark:bg-secondary-900 bg-secondary-50",
        error: "dark:bg-error-900 bg-error-50",
        warning: "dark:bg-warning-900 bg-warning-50",
        success: "dark:bg-success-900 bg-success-50",
        lightblue: "dark:bg-lightblue-900 bg-lightblue-50",
        default: "bg-gray-50 dark:bg-gray-900",
      },
    },
    defaultVariants: {
      intent: "secondary",
    },
  },
);
export type LayeredCirclesProps = {
  className?: string;
  children: ReactNode;
} & VariantProps<typeof layeredCirclesVariantsOuterCircle>;

export const LayeredCircles: React.FC<LayeredCirclesProps> = ({
  intent,
  className,
  children,
}) => {
  return (
    <div
      className={cn(layeredCirclesVariantsOuterCircle({ intent }), className)}
    >
      <div className={cn(layeredCirclesVariantsInnerCircle({ intent }))}>
        {children}
      </div>
    </div>
  );
};
